export default "__VITE_ASSET__DXBdW9LS__"